import type { SVGProps } from 'react';

const SvgExternalLink = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill={props.color} viewBox="0 0 12 12" {...props}>
    <path d="M0 0v12h12V6h-1.333v4.667H1.333V1.333H6V0H0Zm7.333 0v1.333h2.391L3.529 7.53l.942.942 6.196-6.195v2.39H12V0H7.333Z" />
  </svg>
);

export default SvgExternalLink;
